import { render, staticRenderFns } from "./BookingsAndOrders.vue?vue&type=template&id=8317f2c4&scoped=true"
import script from "./BookingsAndOrders.ts?vue&type=script&lang=ts&external"
export * from "./BookingsAndOrders.ts?vue&type=script&lang=ts&external"
import style0 from "./BookingsAndOrders.scss?vue&type=style&index=0&id=8317f2c4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8317f2c4",
  null
  
)

export default component.exports